module.exports = __webpack_public_path__ + "static/media/ui-icons-dashboard-off.91084f4a.svg";